// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "component/arm/v1/arm.proto" (package "viam.component.arm.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Get3DModelsResponse } from "../../../common/v1/common";
import { Get3DModelsRequest } from "../../../common/v1/common";
import { GetGeometriesResponse } from "../../../common/v1/common";
import { GetGeometriesRequest } from "../../../common/v1/common";
import { GetKinematicsResponse } from "../../../common/v1/common";
import { GetKinematicsRequest } from "../../../common/v1/common";
import { GetStatusResponse } from "../../../common/v1/common";
import { GetStatusRequest } from "../../../common/v1/common";
import { DoCommandResponse } from "../../../common/v1/common";
import { DoCommandRequest } from "../../../common/v1/common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../google/protobuf/duration";
import { Pose } from "../../../common/v1/common";
import { Struct } from "../../../google/protobuf/struct";
/**
 * @generated from protobuf message viam.component.arm.v1.GetEndPositionRequest
 */
export interface GetEndPositionRequest {
    /**
     * Name of an arm
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.arm.v1.GetEndPositionResponse
 */
export interface GetEndPositionResponse {
    /**
     * Returns 6d pose of the end effector relative to the base, represented by X,Y,Z coordinates which express
     * millimeters and theta, ox, oy, oz coordinates which express an orientation vector
     *
     * @generated from protobuf field: viam.common.v1.Pose pose = 1;
     */
    pose?: Pose;
}
/**
 * @generated from protobuf message viam.component.arm.v1.JointPositions
 */
export interface JointPositions {
    /**
     * A list of joint positions. Rotations values are in degrees, translational values in mm.
     * There should be 1 entry in the list per joint DOF, ordered spatially from the base toward the end effector of the arm
     *
     * @generated from protobuf field: repeated double values = 1;
     */
    values: number[];
}
/**
 * @generated from protobuf message viam.component.arm.v1.JointVelocities
 */
export interface JointVelocities {
    /**
     * A list of joint velocities. Rotational values are in degrees per second, translational values in mm per second.
     * There should be 1 entry in the list per joint DOF, ordered spatially from the base toward the end effector of the arm.
     *
     * @generated from protobuf field: repeated double values = 1;
     */
    values: number[];
}
/**
 * @generated from protobuf message viam.component.arm.v1.JointAccelerations
 */
export interface JointAccelerations {
    /**
     * A list of joint accelerations. Rotational values are in degrees per second squared, translational values in mm per second squared.
     * There should be 1 entry in the list per joint DOF, ordered spatially from the base toward the end effector of the arm.
     *
     * @generated from protobuf field: repeated double values = 1;
     */
    values: number[];
}
/**
 * @generated from protobuf message viam.component.arm.v1.GetJointPositionsRequest
 */
export interface GetJointPositionsRequest {
    /**
     * Name of an arm
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.arm.v1.GetJointPositionsResponse
 */
export interface GetJointPositionsResponse {
    /**
     * a list JointPositions
     *
     * @generated from protobuf field: viam.component.arm.v1.JointPositions positions = 1;
     */
    positions?: JointPositions;
}
/**
 * Moves an arm to the specified pose that is within the reference frame of the arm.
 * Move request in Motion API has the same behavior except that it performs obstacle avoidance when a world_state
 * message is specified.
 *
 * @generated from protobuf message viam.component.arm.v1.MoveToPositionRequest
 */
export interface MoveToPositionRequest {
    /**
     * Name of an arm
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * The destination to move the arm to; this is from the reference frame of the arm.
     *
     * @generated from protobuf field: viam.common.v1.Pose to = 2;
     */
    to?: Pose;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.arm.v1.MoveToPositionResponse
 */
export interface MoveToPositionResponse {
}
/**
 * @generated from protobuf message viam.component.arm.v1.MoveToJointPositionsRequest
 */
export interface MoveToJointPositionsRequest {
    /**
     * Name of an arm
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * A list of joint positions
     * There should be 1 entry in the list per joint DOF, ordered spatially from the base toward the end effector
     *
     * @generated from protobuf field: viam.component.arm.v1.JointPositions positions = 2;
     */
    positions?: JointPositions;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.arm.v1.MoveToJointPositionsResponse
 */
export interface MoveToJointPositionsResponse {
}
/**
 * @generated from protobuf message viam.component.arm.v1.MoveThroughJointPositionsRequest
 */
export interface MoveThroughJointPositionsRequest {
    /**
     * Name of an arm
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * A list of joint positions which will be moved to in the order they are specified
     *
     * @generated from protobuf field: repeated viam.component.arm.v1.JointPositions positions = 2;
     */
    positions: JointPositions[];
    /**
     * optional specifications to be obeyed during the motion
     *
     * @generated from protobuf field: optional viam.component.arm.v1.MoveOptions options = 3;
     */
    options?: MoveOptions;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.arm.v1.MoveThroughJointPositionsResponse
 */
export interface MoveThroughJointPositionsResponse {
}
/**
 * One waypoint in a streamed joint-space trajectory.
 *
 * @generated from protobuf message viam.component.arm.v1.TrajectoryPoint
 */
export interface TrajectoryPoint {
    /**
     * Time from the start of the motion at which this waypoint should be reached. Must be zero
     * for the first point of the stream and strictly increasing thereafter. Server implementations
     * should validate these constraints.
     *
     * @generated from protobuf field: google.protobuf.Duration time = 1;
     */
    time?: Duration;
    /**
     * Joint positions at this waypoint.
     *
     * @generated from protobuf field: viam.component.arm.v1.JointPositions positions = 2;
     */
    positions?: JointPositions;
    /**
     * Optional target kinematic constraints at this waypoint.
     *
     * @generated from protobuf field: optional viam.component.arm.v1.TrajectoryPoint.KinematicConstraints constraints = 3;
     */
    constraints?: TrajectoryPoint_KinematicConstraints;
}
/**
 * @generated from protobuf message viam.component.arm.v1.TrajectoryPoint.KinematicConstraints
 */
export interface TrajectoryPoint_KinematicConstraints {
    /**
     * Target joint velocities at this waypoint. If provided, the first point of the stream (the t=0 sample)
     * must have zero velocity. Server implementations should validate this constraint.
     *
     * @generated from protobuf field: viam.component.arm.v1.JointVelocities velocities = 1;
     */
    velocities?: JointVelocities;
    /**
     * Optional target joint accelerations at this waypoint.
     *
     * @generated from protobuf field: optional viam.component.arm.v1.JointAccelerations accelerations = 2;
     */
    accelerations?: JointAccelerations;
}
/**
 * @generated from protobuf message viam.component.arm.v1.MoveThroughJointPositionsStreamedRequest
 */
export interface MoveThroughJointPositionsStreamedRequest {
    /**
     * Name of the arm to control.
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "init";
        /**
         * Stream initiation. Sent exactly once and must be the first message on the stream.
         *
         * @generated from protobuf field: viam.component.arm.v1.MoveThroughJointPositionsStreamedRequest.Init init = 2;
         */
        init: MoveThroughJointPositionsStreamedRequest_Init;
    } | {
        oneofKind: "batch";
        /**
         * A batch of trajectory points to append to the running motion. Sent N times after init.
         *
         * @generated from protobuf field: viam.component.arm.v1.MoveThroughJointPositionsStreamedRequest.TrajectoryBatch batch = 3;
         */
        batch: MoveThroughJointPositionsStreamedRequest_TrajectoryBatch;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message viam.component.arm.v1.MoveThroughJointPositionsStreamedRequest.Init
 */
export interface MoveThroughJointPositionsStreamedRequest_Init {
    /**
     * Additional sticky arguments to the method.
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.arm.v1.MoveThroughJointPositionsStreamedRequest.TrajectoryBatch
 */
export interface MoveThroughJointPositionsStreamedRequest_TrajectoryBatch {
    /**
     * Trajectory points to append to the motion, in order. Append-only; points cannot be
     * replaced or revoked.
     *
     * @generated from protobuf field: repeated viam.component.arm.v1.TrajectoryPoint points = 1;
     */
    points: TrajectoryPoint[];
}
/**
 * Streamed back to the client while an arm is performing a streaming move.
 *
 * @generated from protobuf message viam.component.arm.v1.MoveThroughJointPositionsStreamedResponse
 */
export interface MoveThroughJointPositionsStreamedResponse {
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "ack";
        /**
         * @generated from protobuf field: viam.component.arm.v1.MoveThroughJointPositionsStreamedResponse.BatchAck ack = 1;
         */
        ack: MoveThroughJointPositionsStreamedResponse_BatchAck;
    } | {
        oneofKind: undefined;
    };
}
/**
 * BatchAck is returned by arm implementations to ack a
 * `TrajectoryBatch`. Due to the lack of actionable payload in
 * `BatchAck`, Arm implementations are not currently obligated to
 * ack every batch, or even any batch. It is currently unspecified
 * whether ack'ing a batch indicates its acceptance, issue to the
 * arm, or completion. These very relaxed requirements may become
 * tighter if and when `BatchAck` messages begin carrying meaningful
 * payloads back to the client. For now, the recommended practice
 * for arm implementors is to ack each batch that has been
 * successfully issued/enqueued to the arm.
 *
 * @generated from protobuf message viam.component.arm.v1.MoveThroughJointPositionsStreamedResponse.BatchAck
 */
export interface MoveThroughJointPositionsStreamedResponse_BatchAck {
    /**
     * Additional reply data
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.arm.v1.StopRequest
 */
export interface StopRequest {
    /**
     * Name of an arm
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.arm.v1.StopResponse
 */
export interface StopResponse {
}
/**
 * @generated from protobuf message viam.component.arm.v1.Status
 */
export interface Status {
    /**
     * @generated from protobuf field: viam.common.v1.Pose end_position = 1;
     */
    endPosition?: Pose;
    /**
     * @generated from protobuf field: viam.component.arm.v1.JointPositions joint_positions = 2;
     */
    jointPositions?: JointPositions;
    /**
     * @generated from protobuf field: bool is_moving = 3;
     */
    isMoving: boolean;
}
/**
 * @generated from protobuf message viam.component.arm.v1.IsMovingRequest
 */
export interface IsMovingRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.component.arm.v1.IsMovingResponse
 */
export interface IsMovingResponse {
    /**
     * @generated from protobuf field: bool is_moving = 1;
     */
    isMoving: boolean;
}
/**
 * MoveOptions specifies kinematic constraints for an arm motion. All fields
 * are optional ceilings; any combination may be set. Every constraint that
 * is set is respected at every point along the executed trajectory.
 * The limiting constraint may change throughout execution.
 *
 * @generated from protobuf message viam.component.arm.v1.MoveOptions
 */
export interface MoveOptions {
    /**
     * Maximum allowable velocity of an arm joint, in degrees per second.
     * The arm driver will move as fast as possible up to the set value.
     * Ignored when max_vel_degs_per_sec_joints is set.
     *
     * @generated from protobuf field: optional double max_vel_degs_per_sec = 1;
     */
    maxVelDegsPerSec?: number;
    /**
     * Maximum allowable acceleration of an arm joint, in degrees per second squared.
     * The arm driver will accelerate as fast as possible up to the set value.
     * ignored when max_acc_degs_per_sec2_joints is set.
     *
     * @generated from protobuf field: optional double max_acc_degs_per_sec2 = 2;
     */
    maxAccDegsPerSec2?: number;
    /**
     * Per-joint maximum velocity in degrees per second.
     * The arm driver will move each joint as fast as possible up to its respective set value.
     *
     * @generated from protobuf field: repeated double max_vel_degs_per_sec_joints = 3;
     */
    maxVelDegsPerSecJoints: number[];
    /**
     * Per-joint maximum acceleration in degrees per second squared.
     * The arm driver will accelerate each joint as fast as possible up to its respective set value.
     *
     * @generated from protobuf field: repeated double max_acc_degs_per_sec2_joints = 4;
     */
    maxAccDegsPerSec2Joints: number[];
    /**
     * Maximum allowable speed of an arm's tool center point in meters per second.
     * The arm driver will move the tool center point as fast as possible up to this set value.
     *
     * @generated from protobuf field: optional double max_tcp_speed = 5;
     */
    maxTcpSpeed?: number;
}
/**
 * @generated from protobuf message viam.component.arm.v1.SetManualModeRequest
 */
export interface SetManualModeRequest {
    /**
     * Name of an arm
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * True to enter manual mode, false to exit it
     *
     * @generated from protobuf field: bool manual_mode = 2;
     */
    manualMode: boolean;
    /**
     * How long to stay in manual mode, in seconds; 0 means no time limit
     *
     * @generated from protobuf field: int32 enabled_for = 3;
     */
    enabledFor: number;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.arm.v1.SetManualModeResponse
 */
export interface SetManualModeResponse {
}
/**
 * @generated from protobuf message viam.component.arm.v1.GetManualModeRequest
 */
export interface GetManualModeRequest {
    /**
     * Name of an arm
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.arm.v1.GetManualModeResponse
 */
export interface GetManualModeResponse {
    /**
     * True if the arm is in manual mode
     *
     * @generated from protobuf field: bool manual_mode = 1;
     */
    manualMode: boolean;
}
/**
 * @generated from protobuf message viam.component.arm.v1.GetPropertiesRequest
 */
export interface GetPropertiesRequest {
    /**
     * Name of an arm
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.arm.v1.GetPropertiesResponse
 */
export interface GetPropertiesResponse {
    /**
     * True if the arm supports software-enabled manual mode
     *
     * @generated from protobuf field: bool support_manual_mode = 1;
     */
    supportManualMode: boolean;
    /**
     * True if the arm supports direct cartesian commands (MoveToPosition is implemented)
     *
     * @generated from protobuf field: bool support_cartesian_commands = 2;
     */
    supportCartesianCommands: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class GetEndPositionRequest$Type extends MessageType<GetEndPositionRequest> {
    constructor() {
        super("viam.component.arm.v1.GetEndPositionRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.GetEndPositionRequest
 */
export const GetEndPositionRequest = new GetEndPositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEndPositionResponse$Type extends MessageType<GetEndPositionResponse> {
    constructor() {
        super("viam.component.arm.v1.GetEndPositionResponse", [
            { no: 1, name: "pose", kind: "message", T: () => Pose }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.GetEndPositionResponse
 */
export const GetEndPositionResponse = new GetEndPositionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JointPositions$Type extends MessageType<JointPositions> {
    constructor() {
        super("viam.component.arm.v1.JointPositions", [
            { no: 1, name: "values", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.JointPositions
 */
export const JointPositions = new JointPositions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JointVelocities$Type extends MessageType<JointVelocities> {
    constructor() {
        super("viam.component.arm.v1.JointVelocities", [
            { no: 1, name: "values", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.JointVelocities
 */
export const JointVelocities = new JointVelocities$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JointAccelerations$Type extends MessageType<JointAccelerations> {
    constructor() {
        super("viam.component.arm.v1.JointAccelerations", [
            { no: 1, name: "values", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.JointAccelerations
 */
export const JointAccelerations = new JointAccelerations$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJointPositionsRequest$Type extends MessageType<GetJointPositionsRequest> {
    constructor() {
        super("viam.component.arm.v1.GetJointPositionsRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.GetJointPositionsRequest
 */
export const GetJointPositionsRequest = new GetJointPositionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJointPositionsResponse$Type extends MessageType<GetJointPositionsResponse> {
    constructor() {
        super("viam.component.arm.v1.GetJointPositionsResponse", [
            { no: 1, name: "positions", kind: "message", T: () => JointPositions }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.GetJointPositionsResponse
 */
export const GetJointPositionsResponse = new GetJointPositionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveToPositionRequest$Type extends MessageType<MoveToPositionRequest> {
    constructor() {
        super("viam.component.arm.v1.MoveToPositionRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "to", kind: "message", T: () => Pose },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveToPositionRequest
 */
export const MoveToPositionRequest = new MoveToPositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveToPositionResponse$Type extends MessageType<MoveToPositionResponse> {
    constructor() {
        super("viam.component.arm.v1.MoveToPositionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveToPositionResponse
 */
export const MoveToPositionResponse = new MoveToPositionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveToJointPositionsRequest$Type extends MessageType<MoveToJointPositionsRequest> {
    constructor() {
        super("viam.component.arm.v1.MoveToJointPositionsRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "positions", kind: "message", T: () => JointPositions },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveToJointPositionsRequest
 */
export const MoveToJointPositionsRequest = new MoveToJointPositionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveToJointPositionsResponse$Type extends MessageType<MoveToJointPositionsResponse> {
    constructor() {
        super("viam.component.arm.v1.MoveToJointPositionsResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveToJointPositionsResponse
 */
export const MoveToJointPositionsResponse = new MoveToJointPositionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveThroughJointPositionsRequest$Type extends MessageType<MoveThroughJointPositionsRequest> {
    constructor() {
        super("viam.component.arm.v1.MoveThroughJointPositionsRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "positions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JointPositions },
            { no: 3, name: "options", kind: "message", T: () => MoveOptions },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveThroughJointPositionsRequest
 */
export const MoveThroughJointPositionsRequest = new MoveThroughJointPositionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveThroughJointPositionsResponse$Type extends MessageType<MoveThroughJointPositionsResponse> {
    constructor() {
        super("viam.component.arm.v1.MoveThroughJointPositionsResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveThroughJointPositionsResponse
 */
export const MoveThroughJointPositionsResponse = new MoveThroughJointPositionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TrajectoryPoint$Type extends MessageType<TrajectoryPoint> {
    constructor() {
        super("viam.component.arm.v1.TrajectoryPoint", [
            { no: 1, name: "time", kind: "message", T: () => Duration },
            { no: 2, name: "positions", kind: "message", T: () => JointPositions },
            { no: 3, name: "constraints", kind: "message", T: () => TrajectoryPoint_KinematicConstraints }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.TrajectoryPoint
 */
export const TrajectoryPoint = new TrajectoryPoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TrajectoryPoint_KinematicConstraints$Type extends MessageType<TrajectoryPoint_KinematicConstraints> {
    constructor() {
        super("viam.component.arm.v1.TrajectoryPoint.KinematicConstraints", [
            { no: 1, name: "velocities", kind: "message", T: () => JointVelocities },
            { no: 2, name: "accelerations", kind: "message", T: () => JointAccelerations }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.TrajectoryPoint.KinematicConstraints
 */
export const TrajectoryPoint_KinematicConstraints = new TrajectoryPoint_KinematicConstraints$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveThroughJointPositionsStreamedRequest$Type extends MessageType<MoveThroughJointPositionsStreamedRequest> {
    constructor() {
        super("viam.component.arm.v1.MoveThroughJointPositionsStreamedRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "init", kind: "message", oneof: "message", T: () => MoveThroughJointPositionsStreamedRequest_Init },
            { no: 3, name: "batch", kind: "message", oneof: "message", T: () => MoveThroughJointPositionsStreamedRequest_TrajectoryBatch }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveThroughJointPositionsStreamedRequest
 */
export const MoveThroughJointPositionsStreamedRequest = new MoveThroughJointPositionsStreamedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveThroughJointPositionsStreamedRequest_Init$Type extends MessageType<MoveThroughJointPositionsStreamedRequest_Init> {
    constructor() {
        super("viam.component.arm.v1.MoveThroughJointPositionsStreamedRequest.Init", [
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveThroughJointPositionsStreamedRequest.Init
 */
export const MoveThroughJointPositionsStreamedRequest_Init = new MoveThroughJointPositionsStreamedRequest_Init$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveThroughJointPositionsStreamedRequest_TrajectoryBatch$Type extends MessageType<MoveThroughJointPositionsStreamedRequest_TrajectoryBatch> {
    constructor() {
        super("viam.component.arm.v1.MoveThroughJointPositionsStreamedRequest.TrajectoryBatch", [
            { no: 1, name: "points", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TrajectoryPoint }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveThroughJointPositionsStreamedRequest.TrajectoryBatch
 */
export const MoveThroughJointPositionsStreamedRequest_TrajectoryBatch = new MoveThroughJointPositionsStreamedRequest_TrajectoryBatch$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveThroughJointPositionsStreamedResponse$Type extends MessageType<MoveThroughJointPositionsStreamedResponse> {
    constructor() {
        super("viam.component.arm.v1.MoveThroughJointPositionsStreamedResponse", [
            { no: 1, name: "ack", kind: "message", oneof: "message", T: () => MoveThroughJointPositionsStreamedResponse_BatchAck }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveThroughJointPositionsStreamedResponse
 */
export const MoveThroughJointPositionsStreamedResponse = new MoveThroughJointPositionsStreamedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveThroughJointPositionsStreamedResponse_BatchAck$Type extends MessageType<MoveThroughJointPositionsStreamedResponse_BatchAck> {
    constructor() {
        super("viam.component.arm.v1.MoveThroughJointPositionsStreamedResponse.BatchAck", [
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveThroughJointPositionsStreamedResponse.BatchAck
 */
export const MoveThroughJointPositionsStreamedResponse_BatchAck = new MoveThroughJointPositionsStreamedResponse_BatchAck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopRequest$Type extends MessageType<StopRequest> {
    constructor() {
        super("viam.component.arm.v1.StopRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.StopRequest
 */
export const StopRequest = new StopRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopResponse$Type extends MessageType<StopResponse> {
    constructor() {
        super("viam.component.arm.v1.StopResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.StopResponse
 */
export const StopResponse = new StopResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Status$Type extends MessageType<Status> {
    constructor() {
        super("viam.component.arm.v1.Status", [
            { no: 1, name: "end_position", kind: "message", T: () => Pose },
            { no: 2, name: "joint_positions", kind: "message", T: () => JointPositions },
            { no: 3, name: "is_moving", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.Status
 */
export const Status = new Status$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsMovingRequest$Type extends MessageType<IsMovingRequest> {
    constructor() {
        super("viam.component.arm.v1.IsMovingRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.IsMovingRequest
 */
export const IsMovingRequest = new IsMovingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsMovingResponse$Type extends MessageType<IsMovingResponse> {
    constructor() {
        super("viam.component.arm.v1.IsMovingResponse", [
            { no: 1, name: "is_moving", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.IsMovingResponse
 */
export const IsMovingResponse = new IsMovingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveOptions$Type extends MessageType<MoveOptions> {
    constructor() {
        super("viam.component.arm.v1.MoveOptions", [
            { no: 1, name: "max_vel_degs_per_sec", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "max_acc_degs_per_sec2", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "max_vel_degs_per_sec_joints", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "max_acc_degs_per_sec2_joints", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "max_tcp_speed", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.MoveOptions
 */
export const MoveOptions = new MoveOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetManualModeRequest$Type extends MessageType<SetManualModeRequest> {
    constructor() {
        super("viam.component.arm.v1.SetManualModeRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "manual_mode", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "enabled_for", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.SetManualModeRequest
 */
export const SetManualModeRequest = new SetManualModeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetManualModeResponse$Type extends MessageType<SetManualModeResponse> {
    constructor() {
        super("viam.component.arm.v1.SetManualModeResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.SetManualModeResponse
 */
export const SetManualModeResponse = new SetManualModeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetManualModeRequest$Type extends MessageType<GetManualModeRequest> {
    constructor() {
        super("viam.component.arm.v1.GetManualModeRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.GetManualModeRequest
 */
export const GetManualModeRequest = new GetManualModeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetManualModeResponse$Type extends MessageType<GetManualModeResponse> {
    constructor() {
        super("viam.component.arm.v1.GetManualModeResponse", [
            { no: 1, name: "manual_mode", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.GetManualModeResponse
 */
export const GetManualModeResponse = new GetManualModeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPropertiesRequest$Type extends MessageType<GetPropertiesRequest> {
    constructor() {
        super("viam.component.arm.v1.GetPropertiesRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.GetPropertiesRequest
 */
export const GetPropertiesRequest = new GetPropertiesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPropertiesResponse$Type extends MessageType<GetPropertiesResponse> {
    constructor() {
        super("viam.component.arm.v1.GetPropertiesResponse", [
            { no: 1, name: "support_manual_mode", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "support_cartesian_commands", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.arm.v1.GetPropertiesResponse
 */
export const GetPropertiesResponse = new GetPropertiesResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.component.arm.v1.ArmService
 */
export const ArmService = new ServiceType("viam.component.arm.v1.ArmService", [
    { name: "GetEndPosition", options: { "google.api.http": { get: "/viam/api/v1/component/arm/{name}/position" } }, I: GetEndPositionRequest, O: GetEndPositionResponse },
    { name: "MoveToPosition", options: { "google.api.http": { put: "/viam/api/v1/component/arm/{name}/position" }, "viam.common.v1.safety_heartbeat_monitored": true }, I: MoveToPositionRequest, O: MoveToPositionResponse },
    { name: "GetJointPositions", options: { "google.api.http": { get: "/viam/api/v1/component/arm/{name}/joint_positions" } }, I: GetJointPositionsRequest, O: GetJointPositionsResponse },
    { name: "MoveToJointPositions", options: { "google.api.http": { put: "/viam/api/v1/component/arm/{name}/joint_positions" }, "viam.common.v1.safety_heartbeat_monitored": true }, I: MoveToJointPositionsRequest, O: MoveToJointPositionsResponse },
    { name: "MoveThroughJointPositions", options: { "google.api.http": { post: "/viam/api/v1/component/arm/{name}/move_through_joint_positions" }, "viam.common.v1.safety_heartbeat_monitored": true }, I: MoveThroughJointPositionsRequest, O: MoveThroughJointPositionsResponse },
    { name: "MoveThroughJointPositionsStreamed", serverStreaming: true, clientStreaming: true, options: { "viam.common.v1.safety_heartbeat_monitored": true }, I: MoveThroughJointPositionsStreamedRequest, O: MoveThroughJointPositionsStreamedResponse },
    { name: "Stop", options: { "google.api.http": { post: "/viam/api/v1/component/arm/{name}/stop" } }, I: StopRequest, O: StopResponse },
    { name: "IsMoving", options: { "google.api.http": { get: "/viam/api/v1/component/arm/{name}/is_moving" } }, I: IsMovingRequest, O: IsMovingResponse },
    { name: "DoCommand", options: { "google.api.http": { post: "/viam/api/v1/component/arm/{name}/do_command" } }, I: DoCommandRequest, O: DoCommandResponse },
    { name: "GetStatus", options: { "google.api.http": { get: "/viam/api/v1/component/arm/{name}/get_status" } }, I: GetStatusRequest, O: GetStatusResponse },
    { name: "GetKinematics", options: { "google.api.http": { get: "/viam/api/v1/component/arm/{name}/kinematics" } }, I: GetKinematicsRequest, O: GetKinematicsResponse },
    { name: "GetGeometries", options: { "google.api.http": { get: "/viam/api/v1/component/arm/{name}/geometries" } }, I: GetGeometriesRequest, O: GetGeometriesResponse },
    { name: "Get3DModels", options: { "google.api.http": { get: "/viam/api/v1/component/arm/{name}/3d_models" } }, I: Get3DModelsRequest, O: Get3DModelsResponse },
    { name: "SetManualMode", options: { "google.api.http": { put: "/viam/api/v1/component/arm/{name}/manual_mode" } }, I: SetManualModeRequest, O: SetManualModeResponse },
    { name: "GetManualMode", options: { "google.api.http": { get: "/viam/api/v1/component/arm/{name}/manual_mode" } }, I: GetManualModeRequest, O: GetManualModeResponse },
    { name: "GetProperties", options: { "google.api.http": { get: "/viam/api/v1/component/arm/{name}/features" } }, I: GetPropertiesRequest, O: GetPropertiesResponse }
]);
